import { render, staticRenderFns } from "./otherProfitLogCheck.vue?vue&type=template&id=b94a2a98&scoped=true&"
import script from "./otherProfitLogCheck.vue?vue&type=script&lang=js&"
export * from "./otherProfitLogCheck.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b94a2a98",
  null
  
)

export default component.exports